/**
 * `/team/attendance` route — gated on `attendance:read:team` per be-063.
 * Renders the live <TeamAttendanceScreen> list view (Phase 08.2, D-16).
 */
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { TeamAttendanceScreen } from "../features/team/TeamAttendanceScreen.js";

export const Route = createFileRoute("/_auth/team/attendance")({
  staticData: { breadcrumb: { labelKey: "team:nav.attendance" } },
  beforeLoad: requirePermission({
    anyOf: ["attendance:read:team"],
    defaultRoute: "/me/overview",
  }),
  component: TeamAttendanceScreen,
});
